import React, { useEffect, useState } from "react";
import "react-simple-keyboard/build/css/index.css";
//import { bannerList } from "../../config/game-configs";
import moment from "moment";
import useCountDown from 'react-countdown-hook';
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import PinInput from "react-pin-input";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
    Modal,
    ModalBody
} from "reactstrap";
import SecureLS from "secure-ls";
import {
    setBusy,
    setDisplayLogin,
    setDisplayRegister,
    setDisplayForgotPassword,
    setIdle,
    showMessage,
    showResponseMessage
} from "../../redux/AppAction";
import { performLogin } from "../../redux/AuthAction.js";
import { AlertTypes, ApiKey, ApiUrl, PhoneNumberPrefix, SessionKey, WebUrl, LanguageOption, getHostnameReferralCode } from "../../util/Constant";
import ApiEngine from "./../../util/ApiEngine.js";
import {
    createFormBody,
    createMultiPartFormBody,
    stringIsNullOrEmpty
} from "./../../util/Util.js";
import parse from 'react-html-parser';
import { bool } from "prop-types";
import Input from "../../components/custom/Input";

const openEye = "/img/ug/auth/show.svg";
const closedEye = "/img/ug/auth/hide.svg";
const purpleBg = "/img/ug/auth/register-modal-left-bg.jpg";

const Auth = () => {
    const { t, i18n } = useTranslation();
    const _history = useHistory();
    const _dispatch = useDispatch();
    var ls = new SecureLS();
    const _MIN_PASSWORD_LENGTH = 6;
    const _TAC_VALID_TIMER = 300000;
    const _SECONDS_IN_MS = 1000;
    const _TAC_TIMEOUT_IN_MINUTES = 5;
    const initialTime = 120 * 1000;
    const interval = 1000;
    const [isForgetPassword, setIsForgetPassword] = useState(true);
    const [isLogin, setIsLogin] = useState(true);
    const [countdownTime, { start, pause, resume, reset }] = useCountDown(initialTime, interval);

    /* control display login and register*/
    const { isLoggedIn } = useSelector((state) => state.authState);
    let isShowLogin = useSelector((state) => state.appState.isShowLogin);
    let isShowRegister = useSelector((state) => state.appState.isShowRegister);
    let isShowForgotPassword = useSelector((state) => state.appState.isShowForgotPassword);
    let as = useSelector((state) => state.appState);

    const [enteredPinNumber, setEnteredPinNumber] = useState("");
    const [forgetPasswordcountdownTAC, setCountdownTAC] = useState(false);

    /*  login component */
    const [isHiddenLoginPassword, setIsHiddenLoginPassword] = useState(closedEye);
    const [loginPasswordVisible, setLoginPasswordVisible] = useState(false);

    /*  forgot password*/
    const [verifyPhoneTAC, setVerifyPhoneTAC] = useState(false);
    const [isUpdatePassword, setIsUpdatePassword] = useState(false);
    const [isPasswordUpdated, setIsPasswordUpdated] = useState(false);
    const [enteredTAC, setEnteredTAC] = useState("");



    const [isHiddenRegisterPassword, setIsHiddenRegisterPassword] = useState(closedEye);
    const [isHiddenRegisterConfirmPassword, setIsHiddenRegisterConfirmPassword] = useState(closedEye);
    const [newRegisterPasswordVisible, setNewRegisterPasswordVisible] = useState(false);
    const [confirmRegisterPasswordVisible, setConfirmRegisterPasswordVisible] = useState(false);

    const [isHiddenResetPassword, setIsHiddenResetPassword] = useState(closedEye);
    const [isHiddenResetConfirmPassword, setIsHiddenResetConfirmPassword] = useState(closedEye);
    const [newResetPasswordVisible, setNewResetPasswordVisible] = useState(false);
    const [confirmResetPasswordVisible, setConfirmResetPasswordVisible] = useState(false);

    const [keptUsername, setKeptUsername] = useState("");
    const [keptPassword, setKeptPassword] = useState("");
    const [loginFailCount, setLoginFailCount] = useState(0);
    const [usernameLogin, setUsernameLogin] = useState("");
    const [referralCode, setReferralCode] = useState("");
    const [canSendTAC, setCanSendTAC] = useState(true);
    const [TACcountdownPeriod, setTACCountdownPeriod] = useState(0);
    const [TACsent, setTACsent] = useState(false);
    const [countdownPeriod, setCountdownPeriod] = useState(0);
    const [TACtimedOut, setTACtimedOut] = useState(true);
    const [selectedPhonePrefix, setSelectedPhonePrefix] = useState(
        PhoneNumberPrefix[0].value
    );
    const [formattedPhone, setFormattedPhone] = useState("");
    const [phoneNumberError, setPhoneNumberError] = useState(false);
    const [showTacEntry, setShowTacEntry] = useState(false);
    const [TACBtnAble, setTACBtnAble] = useState(false);
    const [TACtimer, setTACtimer] = useState(setTimeout(() => { }, 100000));
    const [isDigit, setIsDigit] = useState(false);
    const [username, setUsername] = useState("");
    const [phoneNum, setPhoneNum] = useState("");
    const [tempPhoneNum, setTempPhoneNum] = useState("");
    const [memberData, setMemberData] = useState({});
    const [showCreateShareholderPin, setShowCreateShareholderPin] = useState(false);
    const [uplineDetail, setUplineDetail] = useState({});
    const [registerPopupContent, setRegisterPopupContent] = useState("");

    const verifyState = {
        button: "1"
    };


    const {
        register: registerLogin,
        handleSubmit: handleSubmitLogin,
        setValue: setValueLogin,
        getValues: getValuesLogin,
        watch: watchLogin,
        errors: errorsLogin,
    } = useForm();

    const {
        register: checkReferralRegister,
        handleSubmit: handleSubmitCheckReferral,
        errors: checkReferralErrors,
        unregister: checkReferralUnregister
    } = useForm();


    const {
        register: registerRegister,
        handleSubmit: handleSubmitRegister,
        errors: errorsRegister,
        setError: setErrorRegister,
        clearErrors: clearErrorsRegister,
        setValue: setValueRegister,
        getValues: getValuesRegister,
        watch: watchRegister,
        control: controlRegister,
        trigger: triggerRegister,
        phoneNumberChk: phoneNumberChkRegister,
        reset: resetRegister
    } = useForm({
        mode: "onBlur",
    });

    const {
        register: forgotPasswordRegister,
        handleSubmit: forgotPasswordHandleSubmit,
        errors: forgotPasswordErrors,
        unregister: forgotPasswordUnregister
    } = useForm();

    const {
        register: tacVerifyRegister,
        handleSubmit: tacVerifyHandleSubmit,
        unregister: tacVerifyUnregister
    } = useForm();
    const {
        register: ResetPasswordRegister,
        handleSubmit: ResetPasswordHandleSubmit,
        errors: ResetPasswordErrors,
        watch: ResetPasswordWatch,
        setValue: ResetPasswordSetValue,
        unregister: ResetPasswordUnregister,
        watch,
    } = useForm();
    const {
        handleSubmit: PasswordUpdatedHandleSubmit,
    } = useForm();
    const countryCodeData = [
        {
            code: "+60",
        },
        {
            code: "+61",
        },
        {
            code: "+62",
        },
        {
            code: "+63",
        },
    ];

    const [isCheckingReferral, setIsCheckingReferral] = useState(false);

    //use effect function start region ---------------------------------------------------------------------


    //trigger after send TAC request count down period
    useEffect(() => {
        if (countdownPeriod > 0) {
            setTimeout(() => {
                let tempPeriod = countdownPeriod - 1;
                setCountdownPeriod(tempPeriod);
            }, _SECONDS_IN_MS);
            // }, 10);
        }
    }, [countdownPeriod]);


    //trigger TAC valid count down period
    useEffect(() => {
        if (TACcountdownPeriod > 0) {
            setTACtimer(setTimeout(() => {
                let tempPeriod = TACcountdownPeriod - 1;
                setTACCountdownPeriod(tempPeriod);
            }, _SECONDS_IN_MS));
            // }, 10));
        }
    }, [TACcountdownPeriod]);

    //use effect function end region ---------------------------------------------------------------------


    //api function start region ---------------------------------------------------------------------

    //submit login 
    const submitLoginForm = async (data, e) => {
        _dispatch(setBusy());
        localStorage.setItem(SessionKey._ISSHOWMINIGAMETRIGGER, true);
        _dispatch(setDisplayLogin(false));
        if (data.isKeepedPassword) {
            ls.set("gR97lPRIn797", {
                Do3SwI4cuvqR: data.loginUsername,
                gR1IPGBN01dS: data.loginPassword,
                PYTLczcty9uH: data.isKeepedPassword,
            });
        } else {
            ls.set("gR97lPRIn797", {
                Do3SwI4cuvqR: "",
                gR1IPGBN01dS: "",
                PYTLczcty9uH: false,
            });
        }
        await _dispatch(
            performLogin(data.loginUsername, data.loginPassword, data.isKeepedLogin)
        );
        let params = {
            username: data.loginUsername,
        };
        var loginFailCountJson = await ApiEngine.post(
            ApiUrl._API_GET_LOGIN_FAILED_COUNT,
            createFormBody(params)
        );
        if (loginFailCountJson[ApiKey._API_SUCCESS_KEY]) {
            let data = loginFailCountJson[ApiKey._API_DATA_KEY];
            setLoginFailCount(data);
        }
        _dispatch(setIdle());
    }

    //check referral exist

    async function submitCheckReferralCode() {
        setIsCheckingReferral(true);
        let responseJson = await ApiEngine.get(
            ApiUrl._API_GET_UPLINE_BY_REFERRAL_CODE + "?code=" + referralCode
        );
        if (responseJson[ApiKey._API_SUCCESS_KEY]) {
            _history.push(WebUrl._URL_REGISTER + "?code=" + referralCode);
            setIsCheckingReferral(false);
            handleCloseRegisterModal();
            resetRegister();
        } else {
            _dispatch(
                showMessage({
                    type: AlertTypes._ERROR,
                    content: t(responseJson[ApiKey._API_MESSAGE_KEY]),
                })
            );
            setIsCheckingReferral(false);
            setReferralCode("");
        }
    }

    //send TAC code
    async function sendTACCode() {
        if (
            (TACtimedOut || countdownPeriod > 0) &&
            typeof formattedPhone !== "undefined" &&
            (selectedPhonePrefix + formattedPhone).length >= 10
        ) {
            if (!errorsRegister.phoneNumber) {
                let params = {
                    phoneNumber: selectedPhonePrefix + formattedPhone,
                    referralCode: referralCode,
                    languageCode: localStorage.getItem(SessionKey._LANGUAGE) && localStorage.getItem(SessionKey._LANGUAGE) != 'undefined' ?
                        localStorage.getItem(SessionKey._LANGUAGE) : 'id',
                    countdown: countdownPeriod,
                    TACExist: !TACtimedOut,
                };

                let responseJson = await ApiEngine.post(
                    ApiUrl._API_SEND_TAC_CODE,
                    createFormBody(params)
                );
                if (responseJson[ApiKey._API_SUCCESS_KEY]) {
                    setPhoneNumberError(false);
                    setTACsent(true);
                    setCountdownPeriod(_TAC_VALID_TIMER / _SECONDS_IN_MS);
                    setShowTacEntry(true);
                    setTACBtnAble(false);
                    setTimeout(() => {
                        setTACBtnAble(true);
                        setTACtimedOut(true);
                    }, _TAC_VALID_TIMER);
                } else {
                    setPhoneNumberError(true);
                }
            }
        } else {
            setErrorRegister("registerPhone", { message: "PHONE_NUMBER_INVALID" });
        }
        setCanSendTAC(false);
        clearTimeout(TACtimer);
        setTACCountdownPeriod((_TAC_VALID_TIMER / _SECONDS_IN_MS));
        setTimeout(() => {
            setCanSendTAC(true);
        }, _SECONDS_IN_MS * 60 * _TAC_TIMEOUT_IN_MINUTES);
    }

    //submit forgot password
    async function submitForgotPasswordForm(data) {

        _dispatch(setBusy());
        let formData = {
            "language": i18n.language,
            "username": data.username
        };
        let formBody = createMultiPartFormBody(formData);
        var responseJson = await ApiEngine.post(
            ApiUrl._API_SEND_RESET_PASSWORD_SMS,
            formBody
        );

        if (responseJson[ApiKey._API_SUCCESS_KEY]) {
            setUsername(data.username)
            //setPhoneNumber(responseJson.data)
            setTempPhoneNum(responseJson.data)
            setVerifyPhoneTAC(true)
            setIsForgetPassword(false)
            setTimeout(() => {
                setCountdownTAC(true)
            }, 120000);
            start();
            //resetForm();
        }
        else {
            _dispatch(showResponseMessage(false, responseJson[ApiKey._API_MESSAGE_KEY]))
        }
        _dispatch(setIdle());
    }

    async function submitVerifyTAC(data) {
        _dispatch(setBusy());
        if (verifyState.button == 1) {

            let formData = {
                "taccode": data.taccode,
                "username": username
            };
            let formBody = createMultiPartFormBody(formData);
            let TACjson = await ApiEngine.post(
                ApiUrl._API_VERIFY_RESET_PASSWORD_SMS,
                formBody
            );
            if (TACjson[ApiKey._API_SUCCESS_KEY]) {
                setVerifyPhoneTAC(false)
                setIsUpdatePassword(true)
                //resetForm();
            }
        } else if (verifyState.button == 2) {
            let formData = {
                "language": i18n.language,
                "username": username
            };
            let formBody = createMultiPartFormBody(formData);
            //data["phoneNumber"] = formattedPhoneNumber;
            data["language"] = i18n.language;
            var responseJson = await ApiEngine.post(
                ApiUrl._API_SEND_RESET_PASSWORD_SMS,
                formBody
            );

            if (responseJson[ApiKey._API_SUCCESS_KEY]) {
                setCountdownTAC(false)
                setUsername(username)
                //setPhoneNumber(responseJson.data)
                setTempPhoneNum(responseJson.data)
                setVerifyPhoneTAC(true)
                setIsForgetPassword(false)
                setTimeout(() => {
                    setCountdownTAC(true)
                }, 120000);
                reset();
                start();
                //resetForm();
            }
        }

        _dispatch(setIdle());
    }


    async function submitNewPassword(data) {
        _dispatch(setBusy());
        let formData = {
            "newpassword": data.newPassword,
            "confpassword": data.confPassword,
            "username": username
        };
        let formBody = createMultiPartFormBody(formData);

        var responseJson = await ApiEngine.post(
            ApiUrl._API_MEMBER_RESET_PASSWORD_BEFORE_LOGIN,
            formBody
        );

        if (responseJson[ApiKey._API_SUCCESS_KEY]) {
            setIsUpdatePassword(false)
            setIsPasswordUpdated(true)
        }
        _dispatch(setIdle());
    }

    async function submitPasswordUpdated(data) {
        setIsUpdatePassword(false)
        setIsPasswordUpdated(false)
        setIsLogin(false)
        handleCloseForgotPasswordModal()
        setDisplayForgotPassword(false)
    }

    //api function end region ---------------------------------------------------------------------

    //normal function start region ---------------------------------------------------------------------
    const toggleHiddenRegisterPassword = () => {
        setNewRegisterPasswordVisible(!newRegisterPasswordVisible);
        if (isHiddenRegisterPassword === closedEye) {
            setIsHiddenRegisterPassword(openEye);
        } else {
            setIsHiddenRegisterPassword(closedEye);
        }
    };
    const toggleHiddenRegisterConfirmPassword = () => {
        setConfirmRegisterPasswordVisible(!confirmRegisterPasswordVisible);
        if (isHiddenRegisterConfirmPassword === closedEye) {
            setIsHiddenRegisterConfirmPassword(openEye);
        } else {
            setIsHiddenRegisterConfirmPassword(closedEye);
        }
    };
    const toggleHiddenLoginPassword = () => {
        setLoginPasswordVisible(!loginPasswordVisible);
        if (isHiddenLoginPassword === closedEye) {
            setIsHiddenLoginPassword(openEye);
        } else {
            setIsHiddenLoginPassword(closedEye);
        }
    };

    const toggleHiddenResetPassword = () => {
        setNewResetPasswordVisible(!newResetPasswordVisible);
        if (isHiddenResetPassword === closedEye) {
            setIsHiddenResetPassword(openEye);
        } else {
            setIsHiddenResetPassword(closedEye);
        }
    };
    const toggleHiddenResetConfirmPassword = () => {
        setConfirmResetPasswordVisible(!confirmResetPasswordVisible);
        if (isHiddenResetConfirmPassword === closedEye) {
            setIsHiddenResetConfirmPassword(openEye);
        } else {
            setIsHiddenResetConfirmPassword(closedEye);
        }
    };


    const handleReferralCode = (code) => {
        setReferralCode(code);
    };

    function handlePhoneNumber(e) {
        const re = /^[0-9\b]+$/;
        // if (e.target.value === "" || re.test(e.target.value) )
        if (e.target.value.match(re) !== null) {
            setIsDigit(true);
            //  setFormattedPhone(selectedPhonePrefix + e.target.value)
            setFormattedPhone(e.target.value)
        }
        else {
            setIsDigit(false);
        }
    };

    const handleCloseRegisterModal = () => {
        _dispatch(setDisplayRegister(false));
        setReferralCode("");

    }

    const handleCloseRegisterAndOpenSignInModal = () => {
        _dispatch(setDisplayRegister(false));
        setReferralCode("");
        _dispatch(setDisplayLogin(true));

    }
    const handleCloseLoginModal = () => {
        _dispatch(setDisplayLogin(false));
    }
    const handleCloseForgotPasswordModal = () => {
        _dispatch(setDisplayForgotPassword(false));
    }

    //normal function end region ---------------------------------------------------------------------


    return (
        <>
            <Modal
                isOpen={isShowRegister && !isLoggedIn}
                contentClassName="register-popup-modal-body-wrapper modal-brand"
                wrapClassName="register-popup-modal"
                size="xl"
                toggle={() => {
                    handleCloseRegisterModal();
                }}
                centered
            >
                <ModalBody>
                    <div className="register-popup-modal-container" id="register-popup-modal-container">
                        <div className="left-section"
                            style={{ backgroundImage: "url(" + purpleBg + ")" }}
                        >
                            <h2 className="left-section-title">{t("AUTH_HOW_TO_GET_REFERRAL_CODE")}</h2>
                            <ol className="left-section-list">
                                <li className="left-section-list-item">
                                    <div className="left-section-list-number">1</div>
                                    <span>{t("AUTH_REFERRAL_BULLET_1")}</span>
                                </li>
                                <li className="left-section-list-item">
                                    <div className="left-section-list-number">2</div>
                                    <span>{t("AUTH_REFERRAL_BULLET_2")}</span>
                                </li>
                                <li className="left-section-list-item">
                                    <div className="left-section-list-number">3</div>
                                    <span>{t("AUTH_REFERRAL_BULLET_3")}</span>
                                </li>
                                <li className="left-section-list-item">
                                    <div className="left-section-list-number">4</div>
                                    <span>{t("AUTH_REFERRAL_BULLET_4")}</span>
                                </li>
                            </ol>

                            <div className="left-section-tips">
                                <span>
                                    {t("AUTH_REFERRAL_TIPS")}
                                </span>
                            </div>

                            <div className="left-section-footer">
                                <div>{t("AUTH_MIN_DEPOSIT")}</div>
                                <div>{t("AUTH_MIN_WITHDRAWAL")}</div>
                            </div>
                        </div>
                        <div className="right">
                            <div className="register-popup-wrapper">
                                <div className="custom-close-modal">
                                    <div className="modal-title">
                                        {t("REGISTER")}
                                    </div>
                                    <div
                                        className="cursor-pointer"
                                        onClick={() => handleCloseRegisterModal()}
                                    >
                                        <img
                                            src={"/img/ug/auth/modal-close.png"}
                                            className="img-responsive"
                                            alt="close"
                                        />
                                    </div>
                                </div>
                                <form onSubmit={handleSubmitCheckReferral(submitCheckReferralCode)} style={{ width: '100%', alignSelf: 'center' }}>
                                    <div className="referral-code-tips">
                                        {t("PLEASE_ENTER_UPLINE_CODE")}
                                        {/* <div>{t("EXAMPLE_SHORT") + "AbCd3fGH +"}</div> */}
                                    </div>
                                    <input
                                        className="custom-input-style-1 referral-code-input mt-3"
                                        type="text"
                                        name="referralCode"
                                        placeholder="eg. AbCd3fGH +"
                                        ref={checkReferralRegister({
                                            required: "FIELD_REQUIRED",
                                        })}
                                        onChange={(e) => handleReferralCode(e.target.value)}
                                        disabled={isCheckingReferral}
                                        errors={checkReferralErrors}
                                        value={referralCode}
                                    />
                                    <div className="referral-code-desc">
                                        <span style={{ color: "red" }}>*</span>{t("AUTH_REFERRAL_CODE_DESC")}
                                    </div>
                                    {checkReferralErrors.referralCode && (
                                        <div className="invalid-feedback">
                                            {t(checkReferralErrors.referralCode.message)}
                                        </div>
                                    )}
                                    {!stringIsNullOrEmpty(registerPopupContent) && <div className="referral-code-text">
                                        <span className="color-red">*</span>{parse(registerPopupContent)}
                                    </div>}
                                    <button
                                        className="custom-btn-style-1 mt-4"
                                        type="submit"
                                        disabled={isCheckingReferral}
                                    >
                                        {isCheckingReferral ? t("CHECKING_REFERRAL") + "..." : t("REGISTER")}
                                    </button>

                                    <div className="referral-code-sign-in">
                                        <div className="sign-in-desc">{t("AUTH_REFERRAL_CODE_HAVE_AN_ACCOUNT")}</div>
                                        <div
                                            className="sign-in-link"
                                            onClick={() => handleCloseRegisterAndOpenSignInModal()}
                                        > {t("AUTH_SIGN_IN")}
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
            <Modal
                isOpen={isShowLogin && !isLoggedIn}
                contentClassName="login-popup-modal-body-wrapper modal-brand"
                wrapClassName="login-popup-modal"
                toggle={() => {
                    handleCloseLoginModal();
                }}
                centered
            >
                <ModalBody>
                    <div className="login-popup-wrapper-new">
                        <div className="login-contaner-new">
                            <div className="custom-close-modal">
                                <div className="modal-title">
                                    {t("LOGIN")}
                                </div>
                                <div
                                    className="cursor-pointer"
                                    onClick={() => handleCloseLoginModal()}
                                >
                                    <img
                                        src={"/img/ug/auth/modal-close.png"}
                                        className="img-responsive"
                                        alt="close"
                                    />
                                </div>
                            </div>
                            <form onSubmit={handleSubmitLogin(submitLoginForm)}>
                                <div className="font-16 mt-3">
                                    {t("USERNAME")}
                                </div>
                                <input
                                    type="text"
                                    name="loginUsername"
                                    id="loginUsername"
                                    className="login-username custom-input-style-1"
                                    placeholder={t("USERNAME")}
                                    autoComplete="off"
                                    defaultValue={ls.get("gR97lPRIn797")["Do3SwI4cuvqR"]}
                                    ref={registerLogin({
                                        required: true,
                                    })}
                                    errors={errorsLogin}
                                />
                                {errorsLogin.loginUsername && (
                                    <div className="invalid-feedback">
                                        {t(errorsLogin.loginUsername.message)}
                                    </div>
                                )}
                                <div className="font-16 mt-3">
                                    {t("PASSWORD")}
                                </div>
                                <div className="input-with-icon-container">
                                    <input
                                        type={loginPasswordVisible ? "text" : "password"}
                                        name="loginPassword"
                                        id="loginPassword"
                                        className="login-password custom-input-style-1"
                                        placeholder={t("PASSWORD")}
                                        defaultValue={ls.get("gR97lPRIn797")["gR1IPGBN01dS"]}
                                        autoComplete="off"
                                        ref={registerLogin({
                                            required: true,
                                        })}
                                        errors={errorsLogin}
                                    />
                                    {errorsLogin.loginPassword && (
                                        <div className="invalid-feedback">
                                            {t(errorsLogin.loginPassword.message)}
                                        </div>
                                    )}
                                    <div className="input-hidden-icon" onClick={toggleHiddenLoginPassword}>
                                        <img src={isHiddenLoginPassword} alt="password" className="img-responsive" />
                                    </div>
                                </div>
                                <div className="login-checkbox-btn-wrapper mt-3">
                                    <div className="login-keep-logged-in checkbox-wrapper">
                                        <input
                                            type="checkbox"
                                            name="isKeepedLogin"
                                            ref={registerLogin()}
                                            errors={errorsLogin}
                                        />
                                        <span>{t("KEEP_LOGGED_IN")}</span>
                                    </div>
                                    <div className="login-remember-password checkbox-wrapper">
                                        <input
                                            type="checkbox"
                                            name="isKeepedPassword"
                                            ref={registerLogin()}
                                            errors={errorsLogin}
                                            defaultChecked={ls.get("gR97lPRIn797")["PYTLczcty9uH"]}
                                        />
                                        <span>{t("KEEP_PASSWORD")}</span>
                                    </div>
                                </div>
                                <button className="custom-btn-style-1 mt-3" type="submit">
                                    {t("LOGIN")}
                                </button>
                                <div className="text-center mt-3">
                                    {t("DONT_HAVE_AN_ACCOUNT")} <span className="register_txt_btn" onClick={() => { 
                                    const code = getHostnameReferralCode(window.location.hostname);
                                    if (code) {
                                        window.location.href = `https://${window.location.hostname}/register?code=${code}`;
                                    } 
                                    else
                                    {
                                            _dispatch(setDisplayRegister(true)); _dispatch(setDisplayLogin(false)) 
                                    }}}>{t("REGISTER")}</span>
                                </div>
                                <div className="forgot_password_div">
                                    <span className="forgot_password_txt_btn"
                                        onClick={() => { _dispatch(setDisplayForgotPassword(true)); _dispatch(setDisplayLogin(false)); setIsForgetPassword(true) }}
                                    >
                                        {t("FORGOT_PASSWORD")}
                                    </span>
                                </div>

                            </form>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
            <Modal
                isOpen={isShowForgotPassword && !isLoggedIn}
                contentClassName="login-popup-modal-body-wrapper modal-brand"
                wrapClassName="login-popup-modal"
                toggle={() => {
                    handleCloseForgotPasswordModal();
                    setIsForgetPassword(false)
                    setVerifyPhoneTAC(false)
                    setIsUpdatePassword(false)
                    setIsPasswordUpdated(false)
                    setIsLogin(true)
                }}
                centered
            >
                {isForgetPassword && (
                    <form onSubmit={forgotPasswordHandleSubmit(submitForgotPasswordForm)}>

                        <span style={{ color: '#FDBE2F', fontFamily: "Montserrat", size: '16px' }}>{t("FORGOT_PASSWORD")}</span>
                        <hr style={{ background: '#3F4F63' }} />

                        <span style={{ color: 'white', fontFamily: "Montserrat", size: '16px' }}>{t("USERNAME")}</span>

                        <div className="buttonIn">
                            <input
                                type="text"
                                name="username"
                                id="username"
                                className="custom-input-style-1 input"
                                placeholder={t("USERNAME")}
                                autoComplete="off"
                                defaultValue={keptUsername}
                                ref={forgotPasswordRegister({
                                    required: true,
                                })}
                                errors={forgotPasswordErrors}
                            />
                            <button className="custom-btn-style-1 mt-4" type="submit">
                                {t("SEND_VIA_WHATSAPP")}
                            </button>
                        </div>
                        {forgotPasswordErrors.username && (
                            <div className="invalid-feedback">
                                {t(forgotPasswordErrors.username.message)}
                            </div>
                        )}
                    </form>)}

                {verifyPhoneTAC && (
                    <form onSubmit={tacVerifyHandleSubmit(submitVerifyTAC)}>
                        <span style={{ color: '#FDBE2F', fontFamily: "Montserrat", size: '16px' }}>{t("VERIFY_YOUR_NUMBER")}</span>
                        <hr style={{ background: '#3F4F63' }} />

                        <span style={{ color: 'white', fontFamily: "Montserrat", size: '16px' }}>{t("OTP CODE")}</span>
                        <div>
                            <input
                                type="text"
                                id="taccode"
                                name="taccode"
                                ref={tacVerifyRegister()}
                                className="custom-input-style-1 input"
                                style={{ marginTop: '20px' }}
                                placeholder={t("OTP_CODE")}
                                autoComplete="off"
                                onChange={(e) => setEnteredTAC(e.target.value)}
                            />
                            <div className="tac_send" style={{ marginTop: '30px' }}>
                                <span >{t("PHONE_OTP_SEND_TO ")}{tempPhoneNum}</span>
                                <button className="custom-btn-style-1" type="submit" onClick={() => verifyState.button = "1"}>
                                    {t("CONTINUE")}
                                </button>
                                {countdownTime !== 0 &&
                                    <span className="modal-small-p mt-5">
                                        {t("RESET_CODE_IN_SECONDS", { value: moment.duration(countdownTime, 'milliseconds').asSeconds() })}
                                    </span>
                                }

                                {forgetPasswordcountdownTAC && (
                                    <div className="tac_send_again">
                                        <button type="submit" onClick={() => verifyState.button = "2"}>
                                            {t("DIDNT_RECEIVE_A_CODE")}
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </form>
                )}
                {isUpdatePassword && (
                    <form onSubmit={ResetPasswordHandleSubmit(submitNewPassword)}>
                        <span style={{ color: '#FDBE2F', fontFamily: "Montserrat", size: '16px' }}>{t("RESET_YOUR_PASSWORD")}</span>
                        <hr style={{ background: '#3F4F63' }} />
                        <div>
                            <span style={{ color: 'white', fontFamily: "Montserrat", size: '16px' }}>{t("NEW_PASSWORD")}</span>
                            <div className="input-with-icon-container">
                                <input
                                    type={newResetPasswordVisible ? "text" : "password"}
                                    name="newPassword"
                                    id="newPassword"
                                    className="custom-input-style-1 input"
                                    style={{ marginTop: '20px' }}
                                    placeholder={t("NEW_PASSWORD")}
                                    autoComplete="off"
                                    defaultValue={keptUsername}
                                    ref={ResetPasswordRegister({
                                        required: true,
                                        minLength: {
                                            value: _MIN_PASSWORD_LENGTH,
                                            message: t("MIN_CHARACTERS", {
                                                length: _MIN_PASSWORD_LENGTH,
                                            }),
                                        },
                                        validate: (value) =>
                                            watch("confPassword") == "" ||
                                            value == watch("confPassword") ||
                                            "PASSWORD_MISMATCH",
                                    })}
                                    errors={ResetPasswordErrors}
                                /> {ResetPasswordErrors.newPassword && (
                                    <div className="invalid-feedback">
                                        {t(ResetPasswordErrors.newPassword.message)}
                                    </div>
                                )}
                                <div className="input-hidden-icon" onClick={toggleHiddenResetPassword}>
                                    <img src={isHiddenResetPassword} alt="password" className="img-responsive" />
                                </div>
                            </div>
                            <span style={{ color: 'white', fontFamily: "averta-bold", size: '14px' }}>{t("CONFIRM_NEW_PASSWORD")}</span>
                            <div className="input-with-icon-container">
                                <input
                                    type={confirmResetPasswordVisible ? "text" : "password"}
                                    name="confPassword"
                                    id="confPassword"
                                    className="custom-input-style-1 input"
                                    style={{ marginTop: '20px' }}
                                    placeholder={t("CONFIRM_NEW_PASSWORD")}
                                    autoComplete="off"
                                    defaultValue={keptUsername}
                                    ref={ResetPasswordRegister({
                                        required: true,
                                        minLength: {
                                            value: _MIN_PASSWORD_LENGTH,
                                            message: t("MIN_CHARACTERS", {
                                                length: _MIN_PASSWORD_LENGTH,
                                            }),
                                        },
                                        validate: (value) =>
                                            watch("newPassword") == "" ||
                                            value == watch("newPassword") ||
                                            "PASSWORD_MISMATCH",
                                    })}
                                    errors={ResetPasswordErrors}
                                />
                                {ResetPasswordErrors.confPassword && (
                                    <div className="invalid-feedback">
                                        {t(ResetPasswordErrors.confPassword.message)}
                                    </div>
                                )}
                                <div className="input-hidden-icon" onClick={toggleHiddenResetConfirmPassword}>
                                    <img src={isHiddenResetConfirmPassword} alt="password" className="img-responsive" />
                                </div>
                            </div>
                            <button className="custom-btn-style-1" type="submit">
                                {t("RESET_PASSWORD")}
                            </button>
                        </div>
                    </form>
                )}
                {isPasswordUpdated && (
                    <form onSubmit={PasswordUpdatedHandleSubmit(submitPasswordUpdated)}>
                        <div className="reset_password_success">
                            <img
                                src="/img/success_icon.svg"
                                className="logout-white"
                                alt="white nav"
                            />
                            <span style={{ color: 'white', fontFamily: "Montserrat", size: '16px' }}>{t("SUCCESS")}</span>
                            <br />
                            <span style={{ color: 'white', fontFamily: "Montserrat", size: '12px' }}>{t("RESET_PASSWORD_SUCCESS")}</span>
                            <button className="custom-btn-style-1" style={{ position: 'relative', top: '30px' }} type="submit">
                                {t("CLOSE")}
                            </button>
                        </div>
                    </form>
                )}
            </Modal>
        </>
    )
}

export default Auth;